import { RowFields, Widget } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import YearsField from './YearsField';

const SelfEmployed: FunctionComponent = function () {
  return (
    <>
      <RowFields>
        <Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessName />
        <Widget.CreditEmploymentDetailsSelfEmployedDetailsTypeOfBusiness />
      </RowFields>
      <YearsField status="self_employed" />
    </>
  );
};

export default SelfEmployed;
